import React, { useEffect } from "react";
import Styled from "styled-components";
import Sapimg from "../Images/SAPImage.png";
import lie from "../Images/lie.jpg";
export default function Sap() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <DIV>
      <BOX>
        <h1>Short Term Student Project Initiatives</h1>

        <COLOR>
          <TOP>
            <p className="above">
              The Student Project Initiatives are designed to pool in
              innovative, interdisciplinary and cutting-edge research proposals
              from students which could bring in novel questions, develop new
              legal frameworks, rethink methodological approaches, evaluate
              ethical dilemmas and find innovative answers to challenges due to
              intersection of scientific technologies on one hand and existing
              laws on the other hand. It aims at convergence of ideas of student
              community pursuing their studies in different scientific and legal
              backgrounds connecting them robustly to the practical issues in
              their respective domains and also able to comprehend the issues on
              the other side so as to bring in viable solutions. The projects
              may address any new or enduring scholarly question, debate, or
              issue and should seek to find about practical solutions for the
              same. Thus, they can contribute immensely not only to the
              knowledge of their own field of study but can also lead to
              dissemination, sharing and acquisition of knowledge through
              experiences and thus eventually they become major drivers of
              change through their research.
            </p>
            <H4>Who can apply?</H4>

            <p className="below">
              Post graduate students from the discipline of science and law can
              submit project proposals of multidisciplinary character which
              seeks to address various ethical conflicts and debates that arise
              on the intersection of science and law. Call for project proposals
              will be issued time to time in this page as well as on the website
              of the University.
            </p>
          </TOP>
         
        
        </COLOR>
      </BOX>
    </DIV>
  );
}
const H3 = Styled.h3`
    font-family: PT Serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    color: #000000;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
    @media (max-width:395px){
      font-size: 14px;
    }
   `;
const H4 = Styled.h4`
   font-family: PT Serif;
   font-style: normal;
   font-weight: normal;
   font-size: 20px;
   line-height: 16px;
   color:#8585e7;
   @media (max-width:640px){
    font-size: 18px;
  }
  @media (max-width:540px){
    font-size: 16px;
  }
  @media (max-width:395px){
    font-size: 14px;
  }`;
const DIV = Styled.div`

background: #FAFAFA;
display:flex ;
justify-content:center;
align-items: center;
width:100%;
`;

const BOX = Styled.div`

width:85%;
margin:50px auto;
h1{
  font-family: Oswald;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 36px;
  font-weight:500;
  color: #E01E38;
  display:flex;
 }
 @media (max-width:1132px){
 h1{
  font-size: 32px;
  }
}
@media (max-width:1065px){
  h1{
   font-size: 31px;
   }
 }
 @media (max-width:534px){
  h1{
   font-size: 28px;
   }
 }
 @media (max-width:395px){
  padding: 16px;
  h1{
   font-size: 26px;
   }
 }
li{
    margin-left:50px;
    text-align:justify;
    font-size:20px;
    line-height:24px;
    font-family: PT Serif;
   
}
@media (max-width:640px){
   li{
    font-size:18px;
   }
}
@media (max-width:534px){
  li{
    font-size:16px;
  }
 }
 @media (max-width:395px){
  li{
    font-size:14px;
  }
 }
`;
const COLOR = Styled.div`
background:white;
padding:20px 40px;
box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
`;

const TOP = Styled.div`
@media (max-width:530px){
  display:flex;
  flex-direction:column;
  align-items:center;
}
 p.above{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
  }
 p.below{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
 }


`;
